import { render } from "./FireNotesPage.vue?vue&type=template&id=719aab74&scoped=true"
import script from "./FireNotesPage.vue?vue&type=script&lang=ts"
export * from "./FireNotesPage.vue?vue&type=script&lang=ts"

import "./FireNotesPage.vue?vue&type=style&index=0&id=719aab74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-719aab74"

export default script